@if (trapImages$ | async; as trapImages) {
    <div class="dog-trap" [style.background-image]="getBackgroundImage(trapImages)"></div>
}
